<template>
  <div class="scratchandwin">
    <div v-if="link.scratchandwin.title" style="padding:5px">Hi <span style="font-weight:bold; text-transform: capitalize;">{{ playUser }}</span>, your loyalty and support has not gone unnoticed. Play our <b>Scratch and Win</b> game for a chance to win free/discounted upgrades or free Slink Cards.</div>
    <scratch-card class="scratchandwin" :key="renderCount"
      :cardWidth="link.scratchandwin.width"
      :cardHeight="link.scratchandwin.height"
      :finishPercent="75"
      :imageUrl="link.scratchandwin.image"
      :forceReveal="forceReveal"
      style="aspect-ratio:300/150; width:100%; height:unset; overflow:hidden; " v-bind:style="link.scratchandwin.style"
      @complete="prizeClaimed()">
        <!-- <div class="card-content" v-html="prize.prize" v-bind:class="{shake: forceReveal}" style="text-transform: uppercase"></div> -->
        <div class="card-content prizeReveal" v-bind:class="{shake: forceReveal}">
          <div class="prize" v-html="prize.prize"></div>
          <div v-if="link.scratchandwin.emailClaim" style="display:flex; gap: 5px; padding:0 5px 10px;">

          <md-input-container md-inline style="padding:0 0px; margin:unset; min-height:unset">
            <!-- <label style="padding:0 20px;">Enter email to claim</label> -->
            <md-input v-model="collectData.name" type="text" style="padding:0 10px; border:1px solid silver; border-radius:5px;text-transform: uppercase" placeholder="Name"></md-input>
            <!-- <md-button @click="collectEmail()" :disabled="!collectData" class="md-dense" style="font-weight:bold; margin:unset; max-height:32px; border:1px solid silver; border-radius: 0 10px 10px 0">Claim</md-button> -->
          </md-input-container>
          <md-input-container md-inline v-if="link.scratchandwin.emailClaim" style="padding:0 0px; margin:unset; min-height:unset">
            <!-- <label style="padding:0 20px;">Enter email to claim</label> -->
            <md-input v-model="collectData.tel" type="tel" style="padding:0 10px; border:1px solid silver; border-radius:5px;text-transform: uppercase" placeholder="Telephone"></md-input>
            <!-- <md-button @click="collectEmail()" :disabled="!collectData" class="md-dense" style="font-weight:bold; margin:unset; max-height:32px; border:1px solid silver; border-radius: 0 10px 10px 0">Claim</md-button> -->
          </md-input-container>
            <md-button @click="collectEmail()" :disabled="!collectData.name || !collectData.tel" class="md-dense md-primary" style="font-weight:bold; margin:unset; max-height:32px; border:1px solid silver; border-radius: 5px">Claim</md-button>


        </div>
          
       
          <div v-else class="description" @click="claimPrize()" style="padding:0 0px; margin:unset; min-height:42px" v-html="prize.description"></div>
        </div>
        <!-- <div>claim</div> -->
        <!-- <div>TEST</div> -->
      </scratch-card>
      
 <!-- <div>{{ renderCount }} </div> -->
 <!-- <button @click="renderCount++">Force Reset</button> -->


  </div>
</template>

<script>
  import Firebase from 'firebase' 
  import {fb} from './firebaseconfig'
  import { analytics } from "./firebaseconfig";
  import ScratchCard from 'vue-scratchcard';

  // import { GoogleMapsApiLoader } from '@googlemaps/js-api-loader';
  let db = fb.database();
  

  export default {
    components: { 
      ScratchCard,
    },
    props: {
      user: Object,
      link: Object,
      // mapObject: Object,
      // mapConfig: Object,
      // apiKey: String,
    },
    metaInfo () {
      return {
        link: [
            // { rel: 'stylesheet', href: this.customFont },
        ],
        meta: [
        ],
        // title: this.getPageTitle,
        script: [
          // { src: "https://maps.googleapis.com/maps/api/js?key=AIzaSyATqN1_rSJJjA29Z6_KmsAS4FX6P9dQ9JE&callback=initMap"},
          // {innerHTML: '(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({ key: "AIzaSyATqN1_rSJJjA29Z6_KmsAS4FX6P9dQ9JE", v: "weekly",});', async: true, defer: true},
          // { innerHTML: this.getMapScript }
        ],
        noscript: [
          // { innerHTML: this.fbPixelNoScript }
        ]
      }
    },
    data() {
      return {
        renderCount: 0,
        forceReveal: false,
        playUser: this.$route.params.user,
        prize: this.getPrize(),
        collectData: {"name": null, "tel": null},
      }
    },
    computed: {
      availablePrizes(){
        return Object.keys(this.link.scratchandwinprizes).filter((prizeKey) => !this.link.scratchandwinprizes[prizeKey].winner);
      },
     
    },
    methods: {
      claimPrize(){

window.open(this.prize.prizeLink);
      },
      getPrize(){
        const availablePrizes = Object.keys(this.link.scratchandwinprizes).filter((prizeKey) => !this.link.scratchandwinprizes[prizeKey].winner);
        const prizeKeys = Object.keys(availablePrizes);
        const randomIndex = Math.floor(Math.random() * prizeKeys.length);
        const randomPrizeKey = prizeKeys[randomIndex];
        return this.link.scratchandwinprizes[randomPrizeKey];
      },
      prizeClaimed(){
        console.log('completed')
      },
      collectEmail:function(){
        
        let destinationEmail = this.link.scratchandwin.email
        var payload = {
          email: destinationEmail,
          template: 2597607,
          subject: 'New Collected Phone Number',
          variables:{
            collectedName: this.collectData.name,
            collectedEmail: this.collectData.tel,
            collectedLink: "Scratch and Win " + this.user.url
          }
        };
        var data = new FormData();
        data.append( "json", JSON.stringify( payload ) );
        fetch("../api/notificationEmail",
        {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          credentials: "same-origin",
          mode: "no-cors",
          method: "POST",
          body: JSON.stringify( payload )
        }).then(res => {
          console.log(res);
          // this.openLink()
          window.open(this.link.scratchandwin.prizeLink);
          this.collectData = "thank you"
        });
      },
    },
    mounted () {
      // console.log(this.playUser)
      
      
    },
    beforeCreate () {
      
    },
    created () {

      // console.log('username', this.user.url)
    }
  }
</script>
<style>
.md-input-container:after{
  visibility:hidden;
}
.scratchcard-content{
  /* display: flex !important; */
  align-items: center;
  justify-content: center;
  
}

.scratchcard-overlay{
  object-fit:cover;
  object-position: center;
}

.prizeReveal{
  display: flex;
  flex-flow: column;
  /* gap: 5px; */
  text-align: center;
  /* padding: 20px; */
  
  text-transform: uppercase;
}

.prizeReveal .prize{
  font-size:xx-large;
  font-weight: bold;
  line-height:35px;
  
  
}

.prizeReveal .description{
  font-size: normal;
  font-weight: normal;
  font-weight:bold;
}

</style>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/scratchandwin.vue